import { ReactNode } from 'react'

import { theme } from '../../constants'
import { StyleProps } from '../../utils/create-styles'
import { Flex } from '../Flex'

export const ContentPageSidebarHeader = (props: {
  children: ReactNode
  styles?: StyleProps
}) => {
  return (
    <Flex
      styles={{
        alignItems: 'center',
        borderBottom: theme.border.style.thinLight,
        minHeight: 42,
        px: 3,
        ...props.styles,
      }}
    >
      {props.children}
    </Flex>
  )
}
